import api from 'src/services/api';
import { readStorage, writeStorage } from 'src/services/storage';

const applyAuthHeader = (token: string): void => {
  if (!token) {
    delete api.defaults.headers.common.Authorization;
    return;
  }

  api.defaults.headers.common.Authorization = `Bearer ${token}`;
};

export const getToken = (): string => {
  return readStorage().serverToken;
};

export const setToken = (token: string): void => {
  writeStorage({ serverToken: token });
  applyAuthHeader(token);
};

export const clearSession = (): void => {
  setToken('');
};

export const primeSessionFromStorage = (): void => {
  const token = getToken();
  if (token) {
    applyAuthHeader(token);
  }
};
